import React from 'react';
import { Title, useTranslate } from 'react-admin';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import SalesPanel from '../components/sales/SalesPanel';
import EventSessionUrlScopeBar from '../components/events/EventSessionUrlScopeBar';
import { getSalesPageTitle } from '../utils/salesUtils';

const SalesPage = () => {
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const eventID = searchParams.get('eventID');
  const userID = searchParams.get('userID');
  const stockID = searchParams.get('stockID');
  const { title } = getSalesPageTitle(eventID, stockID, userID, translate);

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Title title={title} />
      {eventID ? <EventSessionUrlScopeBar eventID={eventID} /> : null}
      <SalesPanel eventID={eventID} stockID={stockID} userID={userID} />
    </Box>
  );
};

export default SalesPage;
